module.exports = __webpack_public_path__ + "img/rm-lead-capture-footer.4dc61491.png";